

































import { defineComponent, getCurrentInstance, ref, watch } from 'vue';
import { BvModalEvent } from 'bootstrap-vue';
import { useDocumentExport } from '../../composables/documents/useDocumentExport';
import { useModal } from '../../../shared/composables/useModal';

export default defineComponent({
  name: 'DocumentExportModal',
  props: {
    documentIds: { type: Array as () => number[], required: true },
  },
  setup(props) {
    const { proxy } = getCurrentInstance() as any;
    const { isVisible, hide, show } = useModal();
    const { isExporting, isExportFailed, fileProgress, downloadUrl, startExportDocuments, resetState } =
      useDocumentExport();

    const liveStatus = ref('');
    let lastAnnouncedBucket = -1;

    watch([fileProgress, downloadUrl, isExportFailed], ([progress, url, failed]) => {
      if (failed) {
        liveStatus.value = '';
        return;
      }
      if (url) {
        liveStatus.value = proxy.$t('document.export_ready_to_download');
        return;
      }
      const bucket = Math.floor((progress as number) / 25);
      if (bucket !== lastAnnouncedBucket) {
        lastAnnouncedBucket = bucket;
        liveStatus.value = proxy.$t('document.export_in_progress_percent', {
          percent: Math.round(progress as number),
        });
      }
    });

    const handleHidden = () => {
      liveStatus.value = '';
      lastAnnouncedBucket = -1;
      resetState();
    };
    const handleCancel = () => {
      hide();
    };
    const handleShown = () => {
      startExportDocuments(props.documentIds);
    };
    const handleOk = (event: BvModalEvent) => {
      if (downloadUrl.value) {
        window.open(downloadUrl.value, '_blank');
      } else {
        event.preventDefault();
      }
    };

    return {
      isVisible,
      isExporting,
      isExportFailed,
      fileProgress,
      downloadUrl,
      liveStatus,
      show,
      hide,
      handleHidden,
      handleCancel,
      handleOk,
      handleShown,
    };
  },
});
